import { DateTime } from 'luxon';
import { PeriodicRevenue, PeriodicCount } from './stats';

export namespace StatsParsers {
  export type PeriodicCountJson = {
    periodStart: string;
    count: number;
  };

  export type PeriodicRevenueJson = PeriodicCountJson & {
    revenue: number;
    tax: number;
    taxableTotal: number;
    nonTaxableTotal: number;
  };

  export function toPeriodicRevenue(input: PeriodicRevenueJson): PeriodicRevenue {
    return {
      ...toPeriodicCount(input),
      revenue: input.revenue,
      tax: input.tax,
      taxableTotal: input.taxableTotal,
      nonTaxableTotal: input.nonTaxableTotal,
    };
  }

  export function toPeriodicCount(input: PeriodicCountJson): PeriodicCount {
    return {
      periodStart: DateTime.fromISO(input.periodStart, { setZone: true }),
      count: input.count,
    };
  }
}
